import React, { Component } from 'react';
import "./index.less";
import ShowModal from '../../components/showModal/index.jsx';
import {requests,messageShow } from '../../utils/http';
import { AddSiteLogRequest,bindOnwerShop,shopOldApplicationNotExpired } from '../../utils/api';

class DialogAddShopSteps extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      navName: "pc",
      selectPlatform:props.selectPlatform,
      selectPlatformName:props.selectPlatformName,
      listUrl:[],
      payUrl:'',//订购链接
      authUrl:'',//授权链接

      newAuthUrl:'',//旧应用授权链接
      existsOldApp:false,
      expireShops:[],
      showCheckShopConfirm:false,//确认是否订购对话框
      chooseAuthDialog:false,//选择授权app
      applist:[
        {
          active:false,
          appName:'店管家铺货代发',
          useOldAuthUrl:false,//是否使用旧的授权链接
        },
        {
          active:false,
          appName: '店管家分销代发(旧)',
          useOldAuthUrl:true,
        }
      ],
      showExsample:false,//显示示例
      exsamplePicUrl:'',//示例图片地址
    };
  }
  componentDidMount() { //组件挂载到DOM渲染后被执行，只会执行一次。
    var that = this;
    shopOldApplicationNotExpired({ PlatformType:this.state.selectPlatform }).then(res =>{
      if (res.Success){
        this.state.existsOldApp = res.Data.ExistsOldApp;
        this.setState({ existsOldApp:res.Data.ExistsOldApp,expireShops:res.Data.Shops });
      } 
      that.GetAllPlatformLink();
    })
  }
  componentWillReceiveProps(props) {  //监听父元素 传过来值的变化 触发的函数

  }

  //获取授权链接列表
  GetAllPlatformLink() {
    var that = this;
    requests({
      url: "/MyShop/GetAllPlatformLink",
      data: {},
      success: (res) => {
        if (res.Success) {
          var list = res.Data.UrlList;
          let selectPlatform=this.state.selectPlatform;
          let payUrl="";
          let authUrl="";
          let newAuthUrl="";
          
          for(let i=0;i<list.length;i++){
            if(list[i].PlatformType.toLowerCase()==selectPlatform.toLowerCase())
            {
              if(list[i].IosPayUrl=="" || list[i].IosPayUrl == null || list[i].IosPayUrl ==undefined)
              {
                payUrl=decodeURIComponent(list[i].PayUrl);
                authUrl=decodeURIComponent(list[i].AuthUrl);
                newAuthUrl=decodeURIComponent(list[i].NewAuthUrl);
              }else 
               {
                payUrl=decodeURIComponent(list[i].IosPayUrl);
                authUrl=decodeURIComponent(list[i].IosAuthUrl);
                newAuthUrl=decodeURIComponent(list[i].NewAuthUrl);
               }
               
               if(this.state.existsOldApp == false && newAuthUrl != null && newAuthUrl != "" && newAuthUrl != 'undefined')
               {
                  authUrl = newAuthUrl;
               }
            }
          }
          that.setState({
            payUrl,authUrl,newAuthUrl
          })

        } else {

        }
      }
    });

  }

  changeNav = (navName) => {
    this.setState({
      navName: navName,
    })
  }
  showContact=()=>{
    this.props.showContact();
  }
  listenAnthUrl=()=>{
    this.props.sureAuthShop();
    this.setLog("add_shop_step_auth","添加店铺_去授权");
  }

  setLog=(operatorType,operatorTypeName)=>{
    var operator={
      data:{
        OperatorType: operatorType,
        PlatformType :this.state.selectPlatform,
        Remark:operatorTypeName
       }
    }
    AddSiteLogRequest(operator).then();
  }

  gotoBuy(url)
  {
    this.setLog("add_shop_step_pay","添加店铺_去订购")
    if(this.state.selectPlatform == "WxVideo")
    {
      this.showExsample('https://www.dgjapp.com/public/images/fxdf-ph/wxvideo_buy_service_exsample.png');
    }
    else
    {
      var existsOldApp = this.state.existsOldApp;
      if(existsOldApp == true)
        this.setState({ showCheckShopConfirm:true});
      else
        window.open(url);
    }
  }
  keepUpBuy(){
    window.open(this.state.payUrl)
    this.setState({showCheckShopConfirm : false});
  }
  closeCheckShopConfim(){
    this.setState({showCheckShopConfirm : false});
  }
  bindOnwerShopComfir(){
    var data={
      PlatformType : this.state.selectPlatform,
      PlatformShopId : this.state.shopId
    }
    var that = this;
    bindOnwerShop(data).then(res =>{
      if (res.RequestError == true)//请求失效了。isLoading关闭看需求写
      {
          that.setState({ isLoading: false })
          messageShow('绑定失败', "error" );
      }
      if (res.Success) 
      {
          messageShow('绑定成功', "success" );
      } 
      else {
        messageShow("绑定失败：" + res.Message, "error" );
      }
    });
  }
  showExsample(picUrl){
    this.setState({showExsample:true,exsamplePicUrl:picUrl})
  }
  closeExsample(){
    this.setState({showExsample:false,exsamplePicUrl:''})
  }
  selectedApp(item){
    this.state.applist.forEach(e =>{
      e.active = false;
    })
    item.active = true;
    this.setState({applist:this.state.applist});
  }
  authConfirm()
  {
    var appInfo = this.state.applist.find(s => s.active == true);
    if(appInfo != null)
    {
      this.props.sureAuthShop();
      this.setLog("add_shop_step_auth","添加店铺_去授权");
      if(appInfo.useOldAuthUrl == true)
      {
        window.open(this.state.authUrl);
      }
      else{
        window.open(this.state.newAuthUrl);
      }
      this.setState({chooseAuthDialog:false})
    }
  }
  render() {
    return (
      <div className="newAddShop-steps">
        <ul className="newAddShop-steps-nav">
          <li className={this.state.navName == "pc" ? "active" : ""} onClick={() => this.changeNav("pc")}>电脑订购授权</li>
          {/* <li className={this.state.navName == "move" ? "active" : ""} onClick={() => this.changeNav("move")}>手机订购授权</li> */}
        </ul>
        {
          this.state.navName == "pc" ?
            <ul className="newAddShop-steps-pcMain">
              <li>
                <i>1</i>
                {
                  <span>打开{this.state.selectPlatformName}服务市场，订购{
                    this.state.selectPlatform == "Kuaishou" 
                    || this.state.selectPlatform == "Toutiao" 
                    || this.state.selectPlatform == "Pinduoduo" ? "【店管家分销代发】" :
                     this.state.selectPlatform == "Taobao" ? "【店管家_打印电子面单】":"【店管家_铺货代发】"
                  }应用支持7天免费试用</span>
                  // <span>打开{this.state.selectPlatformName}服务市场，订购【店管家分销代发】应用支持7天免费试用</span>
                }
                {/* <span>打开{this.state.selectPlatformName}服务市场，订购【店管家分销代发】应用支持7天免费试用</span> */}
                <a href='javascript:void(0)' onClick={() => this.gotoBuy(this.state.payUrl)}>前往订购</a>
              </li>
              
              {
                this.state.selectPlatform == "WxVideo" ?//&& !this.state.shopId? 
                  <li>
                    <i>2</i>
                    <span>输入视频号小店ID： </span>
                    <input type="text" placeholder='视频号小店ID' style={{"margin-top":"-10px"}} value={this.state.shopId} onChange={(e) => {this.setState({shopId:e.currentTarget.value}) }} />
                    <button className="smaSDefBtn" style={{"margin-top":"-10px"}} onClick={() => this.bindOnwerShopComfir()}>绑定店铺</button>
                    <a href='javascript:void(0)' onClick={()=>{this.showExsample('https://www.dgjapp.com/public/images/fxdf-ph/wxvideo_auth_exspample.png')}} style={{"marginLeft":"20px"}}>示例</a>
                  </li> : null
                  // <li>
                  //   <i>2</i>
                  //   <span>登录{this.state.selectPlatformName}店铺，选择软件去使用</span>
                  //   <a href="" target="_blank" href={this.state.authUrl} onClick={()=>this.listenAnthUrl()}>立即试用</a>
                  // </li> : null
              }
              {
                this.state.selectPlatform != "WxVideo" ?
                <li>
                    <i>2</i>
                    <span>登录{this.state.selectPlatformName}店铺，完成店铺授权</span>
                    {
                      this.state.existsOldApp == true ? <a  href='javascript:void(0)' onClick={()=>{ this.setState({chooseAuthDialog:true}) }}>立即授权</a> :
                      <a target="_blank" href={this.state.authUrl} onClick={()=>this.listenAnthUrl()}>立即授权</a>
                    }
                  </li> :null
              }
              
              <li>
                <i>3</i>
                <span>返回软件内确认授权结果</span>
              </li>
            </ul> : null
        }
        {/* {
          this.state.navName == "move" ?
            <ul className="newAddShop-steps-moveMain">
              <li>
                <div className="newAddShop-steps-moveMain-top">
                  <i className="newAddShop-steps-moveMain-icon">1</i>
                  <span>打开快手APP，扫码订购【店管家分销代发】应用</span>
                </div>
                <img className="newAddShop-steps-moveMain-QrCode" />
              </li>

              <li>
                <div className="newAddShop-steps-moveMain-top">
                  <i className="newAddShop-steps-moveMain-icon">2</i>
                  <span>继续使用快手app扫码，完成授权</span>
                </div>
                <img className="newAddShop-steps-moveMain-QrCode" />
              </li>

              <li>
                <div className="newAddShop-steps-moveMain-top">
                  <i className="newAddShop-steps-moveMain-icon">3</i>
                  <span>返回软件内确认授权结果</span>
                </div>
              </li>
            </ul> : null
        } */}




        {
          this.state.navName == "move" ?
          <div className="newAddShop-steps-moveMain">
            <text>开发中...</text>
          </div>:null
        }


        <div style={{color:'#f7941f',padding:"0 15px"}}>
          <span>因平台接口限制，1688商品铺货到{this.state.selectPlatformName}需要同时订购上下游平台软件并授权，才能铺货和订单回流。因此为保障功能正常使用，请同时订购1688【铺货代发】+{this.state.selectPlatformName}【分销代发】，请悉知！</span>
        </div>


        <div className="newAddShop-steps-pcMain-footer">
          {/* <span onClick={()=>this.showContact()}>
            <i className="iconfont icon-kefu1"></i>
            <span>联系客服</span>
          </span> */}
        </div>
        {
          <div className="exsamplePicWrap" style={{ display: this.state.showExsample ? "flex" : "none" }}>
              <div className="exsamplePicWrap-main">
                  <i className="iconfont icon-shanchu" onClick={() => this.closeExsample()}></i>
                  <img src={this.state.exsamplePicUrl} alt="" />
              </div>
          </div>
        }
        <ShowModal width={"650px"} showModal={this.state.showCheckShopConfirm} hideBtn={true}>
          <div  style={{"fontSize":"12px"}} >
            <div>
              <span className='iconfont icon-gantan' style={{color:"#ff8b00"}}> </span>
              <span> 检测到：</span>
            </div>
            <div>
              {
                 this.state.expireShops != null ?
                  this.state.expireShops.map(shop => {
                    return <p style={{"fontWeight":"500"}}> 【{shop.NikeName}】 店铺服务剩余{ shop.ServiceEndTimeDiff }天</p>
                  }):null
              }
            </div>
            <div>
              登录此店铺订购应用进行授权将不会叠加之前的剩余时间，请在店铺服务到期后再重新订购授权
            </div>
            <div style={{"fontSize":"14px","fontWeight":"700",marginTop:"40px"}}>
              如需添加授权新店铺，请忽略此提示，继续订购
            </div>
          </div>
          <div className="showModalWrap-box-commonfooter">                       
              <span style={{padding:"0 30px"}} className="showModalWrap-box-footer-btn cancleBtn" onClick={()=>this.closeCheckShopConfim()}>关闭</span> 
              <span className="showModalWrap-box-footer-btn" style={{marginLeft:"20px"}} onClick={()=>{this.keepUpBuy()}}>继续订购</span>             
          </div> 
        </ShowModal>

        <ShowModal width={"650px"} showModal={this.state.chooseAuthDialog } titleName='请根据店铺已订购的应用选择进行授权' hideBtn={true}>
          <div className={"chooseApp"}>
            <ul className={"chooseApp-main"}>
                    {
                      this.state.applist.map(a =>{
                         return <li className={ a.active == true ? "active":"" } onClick={()=>{ this.selectedApp(a)  }}>
                                  <span className={"platformName-wrap "}>
                                    {
                                      a.useOldAuthUrl == true ? <i className={"oldAppLogo appLogoLargerIcon"}></i>:<i className={"newAppLogo appLogoLargerIcon"}></i>
                                    }
                                    
                                  </span>
                                  <span class="pintaiName">{a.appName}</span>
                                </li>
                            
                      })
                    }
                  
					        <li style={{"border": "1px solid #fff"}}></li>
              </ul>
          </div>
          
          <div className="showModalWrap-box-commonfooter">    
              <span style={{padding:"0 30px"}} className="showModalWrap-box-footer-btn cancleBtn" onClick={()=>{ this.setState({chooseAuthDialog:false})}}>关闭</span> 
              <span className="showModalWrap-box-footer-btn" style={{marginLeft:"20px"}} onClick={()=>{ this.authConfirm() }}>确认</span>                     
          </div> 
        </ShowModal>

        
      </div>
    );
  }



};

export default DialogAddShopSteps;



// WEBPACK FOOTER //
// ./src/components/dialogAddShopSteps/index.jsx